module.exports = __webpack_public_path__ + "img/guest_list_2-dim_array.71f9abf9.png";